<template>
  <div>
    <p class="font-weight-bold">{{ $t('messages.price') }}</p>
    <vue-slider v-model="range.price" :min="0" :max="300" :enableCross="false" tooltip="always"
                :tooltipFormatter="range.formatter" class="slider-margin ml-3 mr-3"></vue-slider>
    <p class="font-weight-bold mt-2">{{ $t('messages.availability') }}</p>
    <b-form-checkbox-group v-model="params.availability" stacked class="mt-2">
      <b-form-checkbox value="stock_limited" class="checkbox-line-height">{{ $t('messages.stock_almost_sold_out') }}</b-form-checkbox>
      <b-form-checkbox value="stock" class="checkbox-line-height">{{ $t('messages.stock_in') }}</b-form-checkbox>
      <b-form-checkbox value="preorder" class="checkbox-line-height">{{ $t('messages.preorder') }}</b-form-checkbox>
      <b-form-checkbox value="backorder" class="checkbox-line-height">{{ $t('messages.backorder') }}</b-form-checkbox>
    </b-form-checkbox-group>
    <div v-if="publishers.length > 0">
      <p class="font-weight-bold mt-2">{{ $t('messages.publisher') }}</p>
      <div class="publisher_scroll">
        <b-form-checkbox-group v-model="params.publishers" stacked class="mt-2">
          <b-form-checkbox v-for="publisher in publishers" :value="publisher.publisher" :key="'pub-' + publisher.publisher" class="checkbox-line-height">{{ publisher.publisher }}</b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>
    <p class="font-weight-bold mt-2">{{ $t('messages.language') }}</p>
    <b-form-checkbox-group v-model="params.languages" stacked class="mt-2">
      <b-form-checkbox v-for="language in languages" :value="language" :key="'lang-' + language" class="checkbox-line-height">{{ $t('languages.' + language) }}</b-form-checkbox>
    </b-form-checkbox-group>
  </div>
</template>

<script>
import _ from 'lodash'
import VueSlider from 'vue-slider-component'

import '../../assets/css/slider.css'

import { productService } from '../../services/product.service'

import { defaultMixin } from '../../mixin/default'
import { productMixin } from '../../mixin/product'

export default {
  name: 'productfilter',
  mixins: [ defaultMixin, productMixin ],
  components: { VueSlider },
  props: {
    value: Object,
    publishers: Array
  },
  data: function () {
    return {
      params: this.value,
      range: {
        price: [ this.$route.query.minPrice ? parseInt(this.$route.query.minPrice) : 0, this.$route.query.maxPrice ? parseInt(this.$route.query.maxPrice) : 300 ],
        formatter: value => '€ '.concat(value).concat('.00')
      },
      languages: productService.getLanguages()
    }
  },
  watch: {
    'range.price': _.debounce(function () {
      this.params.minPrice = this.range.price[0]
      this.params.maxPrice = this.range.price[1]
    }, 1000)
  }
}
</script>

<style scoped>
  .publisher_scroll {
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .slider-margin {
    margin-top: 40px;
  }

  .checkbox-line-height {
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/ProductFilter.vue